export default __webpack_public_path__ + "static/media/cherub.69967d7e.png";